import {Route,Switch,BrowserRouter } from "react-router-dom";

import DriverShiftsTable from "components/Doobi/DriverShifts";
import DoobiHeader from "components/Headers/DoobiHeader";

const DriverShiftsRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="DriverShifts" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={DriverShiftsTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default DriverShiftsRoute;
